import React, { useEffect, useState } from "react";
import axios from "axios";
import { BASE_URL } from "../BaseUrl";
import Sidebaar from "../Component/Sidebaar";
import TitleComp from "../Component/TitleComp";
import { Box } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";

function Settings() {
  const token = localStorage.getItem("token");

  const [settings, setSettings] = useState([]);
  const [keyName, setKeyName] = useState("");
  const [value, setValue] = useState("");
  const [editId, setEditId] = useState(null);
  const [loading, setLoading] = useState(false);

  const headers = {
    Authorization: `Bearer ${token}`,
  };

  /* ================= GET SETTINGS ================= */
  const getSettings = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${BASE_URL}/settings`, { headers });
      setSettings(res.data.data || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getSettings();
  }, []);

  /* ================= ADD / UPDATE ================= */
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!keyName || !value) return;

    const payload = {
      key: keyName,
      value: value,
    };

    try {
      setLoading(true);

      if (editId) {
        // UPDATE
        await axios.put(
          `${BASE_URL}/settings/${editId}`,
          payload,
          { headers }
        );
      } else {
        // CREATE
        await axios.post(
          `${BASE_URL}/settings`,
          payload,
          { headers }
        );
      }

      resetForm();
      getSettings();
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  /* ================= DELETE ================= */
  const deleteSetting = async (id) => {


    try {
      await axios.delete(`${BASE_URL}/settings/${id}`, { headers });
      getSettings();
    } catch (err) {
      console.error(err);
    }
  };

  /* ================= EDIT ================= */
  const editSetting = (item) => {
    setEditId(item._id);
    setKeyName(item.key);
    setValue(item.value);
  };

  const resetForm = () => {
    setEditId(null);
    setKeyName("");
    setValue("");
  };

  /* ================= DATAGRID ================= */
  const columns = [
    { field: "key", headerName: "Key", flex: 1 },
    { field: "value", headerName: "Value", flex: 1 },
    {
      field: "edit",
      headerName: "Edit",
      flex: 0.5,
      renderCell: (params) => (
        <span
          style={{ cursor: "pointer" }}
          onClick={() => editSetting(params.row)}
        >
          <i className="fa-solid fa-pen-to-square"></i>
        </span>
      ),
    },
    {
      field: "delete",
      headerName: "Delete",
      flex: 0.5,
      renderCell: (params) => (
        <span
          style={{ cursor: "pointer", color: "red" }}
          onClick={() => deleteSetting(params.row._id)}
        >
          <i className="fa-solid fa-trash"></i>
        </span>
      ),
    },
  ];

  return (
    <Sidebaar
      content={
        <div className="container mt-4">
          <TitleComp title="Settings" />

          {/* ===== FORM ===== */}
          <form onSubmit={handleSubmit} className="row g-3 mb-4">
            <div className="col-md-4">
              <label>Key</label>
              <input
                type="text"
                className="form-control"
                value={keyName}
                onChange={(e) => setKeyName(e.target.value)}
              />
            </div>

            <div className="col-md-4">
              <label>Value</label>
              <input
                type="text"
                className="form-control"
                value={value}
                onChange={(e) => setValue(e.target.value)}
              />
            </div>

            <div className="col-md-2 d-flex align-items-end">
              <button className="btn bg-blue text-white" disabled={loading}>
                {editId ? "Update" : "Add"}
              </button>
            </div>

            {editId && (
              <div className="col-md-2 d-flex align-items-end">
                <button
                  type="button"
                  className="btn btn-secondary w-100"
                  onClick={resetForm}
                >
                  Cancel
                </button>
              </div>
            )}
          </form>

          {/* ===== LIST ===== */}
          <Box sx={{ height: 500, width: "100%" }}>
            <DataGrid
              rows={settings}
              columns={columns}
              getRowId={(row) => row._id}
              pageSizeOptions={[5, 10, 25]}
              initialState={{
                pagination: { paginationModel: { pageSize: 10 } },
              }}
              loading={loading}
            />
          </Box>
        </div>
      }
    />
  );
}

export default Settings;
